
//72
Object.defineProperty(exports, "__esModule", { value: true });
require("../../../components/button-next/button-next.st.css");
require("../colors.st.css");
require("../shadows.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "closebutton3200024478",
    {"closeButton":"closebutton3200024478--closeButton","standardFilled":"buttonnext758610631--standardFilled","light":"buttonnext758610631--light","dark":"buttonnext758610631--dark","lightFilled":"buttonnext758610631--lightFilled","transparent":"buttonnext758610631--transparent","medium":"buttonnext758610631--medium","root":"closebutton3200024478--root"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/themes/backoffice/close-button/close-button.st.css
// module id = 1364
// module chunks = 0